export const getDebtorId = () => {
  const debtorId = localStorage.getItem('debtor_id'); // Retrieve the debtor_id from localStorage. The debtor_id is used to fetch related records from the API
  return debtorId;
};

export { getDebtorId as default };
